import type { Session } from "@supabase/supabase-js";
import { aalFromAccessToken, roleFromAccessToken } from "@/lib/jwt";
import { useSession } from "./useSession";

// Pure check — pass in the same session you're already reading elsewhere
// to avoid a hook race (two useSession instances can resolve in different
// microtasks, briefly producing inconsistent isAdmin readings).
export function isAdmin(session: Session | null | undefined): boolean {
  return roleFromAccessToken(session?.access_token) === "admin";
}

// True only when the session is both admin-role AND has cleared the MFA
// challenge (aal2). aal1 admin sessions are intermediate — they've passed
// the password but not yet entered their TOTP code.
export function isAdminVerified(session: Session | null | undefined): boolean {
  return isAdmin(session) && aalFromAccessToken(session?.access_token) === "aal2";
}

// Convenience hook for places that don't already have a session in scope.
// Returns the same `loading` flag as useSession so callers can wait for
// the session to resolve before deciding.
export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const { session, loading } = useSession();
  return { isAdmin: isAdmin(session), loading };
}
